import {Button, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {useFloatingHeader} from '@yandex-delivery/utils/hooks'
import clsx from 'clsx'
import type {ReactElement} from 'react'

import {renderWidget} from '../index@desktop'
import type {ActionButtonWidgetProps as Props} from '../types'
import {useActionButtonProps} from './hooks'
import * as classes from './index@desktop.classes'

export function ActionButtonWidget(props: Props): ReactElement {
  const {sentinelRef} = props
  const {style, loading, size, handlePress, slots, actionElement} =
    useActionButtonProps(props)
  const isFloatingSubmitButton = useFloatingHeader(sentinelRef)

  return (
    <Paper
      className={isFloatingSubmitButton ? classes.root : undefined}
      padding="S"
      radius="L"
    >
      <Button
        data-e2e="submit-button"
        disabled={!style.enabled}
        loading={loading}
        onPress={handlePress}
        size={size}
        variant={style.style === 'main' ? 'action' : 'default'}
        fullWidth
        px="m"
        className={clsx(classes.slotsGrid, {[classes.disabledOpacityOverride]: !style.enabled})}
      >
        {slots.map((slot, i) => (
          <span
            key={i}
            className={
              slot.align === 'leading'
                ? classes.slotLeading
                : slot.align === 'trailing'
                  ? classes.slotTrailing
                  : classes.slotCenter
            }
          >
            {slot.title.items.map(renderWidget)}
            {slot.subtitle && slot.subtitle.items.map(renderWidget)}
          </span>
        ))}
        {actionElement}
      </Button>
    </Paper>
  )
}
